import React, { useEffect, useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const FacilityInfoSection = ({ data, onChange, onSave }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [localData, setLocalData] = useState(data);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    setLocalData(data);
    setIsEditing(false);
    setIsSaving(false);
  }, [data]);

  const handleChange = (field, value) => {
    setLocalData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSave = async () => {
    setIsSaving(true);
    await onSave(localData);
    setIsSaving(false);
    setIsEditing(false);
  };

  const handleCancel = () => {
    setLocalData(data);
    setIsEditing(false);
  };

  return (
    <div className="bg-card rounded-xl border border-border p-4 md:p-6 lg:p-8">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-primary/10 rounded-md flex items-center justify-center">
            <Icon name="Building2" size={20} color="var(--color-primary)" />
          </div>
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground">
              시설 정보
            </h2>
            <p className="text-sm caption text-muted-foreground">
              시설의 기본 정보를 관리합니다
            </p>
          </div>
        </div>
        
        {!isEditing && (
          <Button
            variant="outline"
            size="default"
            iconName="Edit"
            iconPosition="left"
            onClick={() => setIsEditing(true)}
          >
            수정
          </Button>
        )}
      </div>
      <div className="space-y-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6">
          <Input
            label="시설명"
            type="text"
            placeholder="시설 이름을 입력하세요"
            value={localData?.name}
            onChange={(e) => handleChange('name', e?.target?.value)}
            disabled={!isEditing}
            required
          />
          
          <Input
            label="연락처"
            type="tel"
            placeholder="010-1234-5678"
            value={localData?.phone}
            onChange={(e) => handleChange('phone', e?.target?.value)}
            disabled={!isEditing}
            required
          />
        </div>

        <Input
          label="주소"
          type="text"
          placeholder="시설 주소를 입력하세요"
          value={localData?.address}
          onChange={(e) => handleChange('address', e?.target?.value)}
          disabled={!isEditing}
          required
        />

        <Input
          label="주차 정보"
          type="text"
          placeholder="주차 가능 대수 및 안내사항"
          value={localData?.parking}
          onChange={(e) => handleChange('parking', e?.target?.value)}
          disabled={!isEditing}
          description="예: 무료 주차 30대 가능"
        />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6">
          <Input
            label="이메일"
            type="email"
            placeholder="facility@example.com"
            value={localData?.email}
            onChange={(e) => handleChange('email', e?.target?.value)}
            disabled={!isEditing}
          />
          
          <Input
            label="웹사이트"
            type="url"
            placeholder="https://example.com"
            value={localData?.website}
            onChange={(e) => handleChange('website', e?.target?.value)}
            disabled={!isEditing}
          />
        </div>

        {localData?.address && (
          <div className="mt-6">
            <label className="block text-sm font-medium text-foreground mb-2">
              위치 지도
            </label>
            <div className="w-full h-64 md:h-80 lg:h-96 rounded-md overflow-hidden border border-border">
              <iframe
                width="100%"
                height="100%"
                loading="lazy"
                title={localData?.name}
                referrerPolicy="no-referrer-when-downgrade"
                src={`https://www.google.com/maps?q=${encodeURIComponent(localData?.address)}&z=15&output=embed`}
              />
            </div>
          </div>
        )}

        {isEditing && (
          <div className="flex gap-3 pt-4 border-t border-border">
            <Button
              variant="outline"
              onClick={handleCancel}
              disabled={isSaving}
              fullWidth
            >
              취소
            </Button>
            <Button
              variant="default"
              onClick={handleSave}
              loading={isSaving}
              iconName="Save"
              iconPosition="left"
              fullWidth
            >
              저장
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default FacilityInfoSection;